module.exports = __webpack_public_path__ + "img/yunzhuomian.7dbf6d57.png";